@if (status !== 'none') {
  <button
    #trigger
    type="button"
    class="token-chip {{ status }}"
    [class.is-open]="open"
    [class.is-action]="!hasMenu"
    (click)="onChipClick($event)"
    [attr.aria-haspopup]="hasMenu ? 'menu' : null"
    [attr.aria-expanded]="hasMenu ? open : null"
    [attr.aria-label]="hasMenu ? null : actions[0]?.label"
    [attr.title]="hasMenu ? null : actions[0]?.label"
  >
    @if (!hasMenu && actions[0]; as action) {
      @if (action.iconSvg) {
        <span class="token-chip-icon" [innerHTML]="safeIcon(action.iconSvg)" aria-hidden="true"></span>
      } @else if (action.icon) {
        <span class="token-chip-icon {{ action.icon }}" aria-hidden="true"></span>
      }
    }
    <span class="token-chip-label">{{ statusLabel }}</span>
    @if (hasMenu) {
      <svg class="token-caret" viewBox="0 0 10 6" width="9" height="6" aria-hidden="true">
        <path fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" d="M1 1.5 5 5 9 1.5"/>
      </svg>
    }
  </button>

  @if (hasMenu && open) {
    <div class="token-menu" [ngStyle]="{ left: menuLeft + 'px', top: menuTop + 'px' }" (clickOutside)="closeMenu()">
      @for (a of actions; track a.action) {
        <button type="button" class="token-menu-item" (click)="runAction(a.action, $event)">
          <span class="token-menu-icon {{ a.icon }}" aria-hidden="true"></span>
          <span class="token-menu-label">{{ a.label }}</span>
        </button>
      }
    </div>
  }
} @else if (canReissue) {
  <button
    type="button"
    class="token-chip reissue"
    (click)="runAction('reset-enrollment', $event)"
    aria-label="Reissue enrollment"
  >
    <svg class="token-reissue-icon" viewBox="0 0 16 16" aria-hidden="true"
         fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">
      <path d="M12.5 5A5 5 0 0 0 3.5 6.5"/>
      <path d="M3.5 11A5 5 0 0 0 12.5 9.5"/>
      <path d="M12.5 2.5V5H10"/>
      <path d="M3.5 13.5V11H6"/>
    </svg>
    <span class="token-chip-label">Reissue</span>
  </button>
} @else {
  <span class="token-empty">&#8212;</span>
}
